import { IBankAccountModel, routes2 } from '@linqpal/models'
import { useCallback } from 'react'
import { FLOWS } from '../../InvoiceDetails/utils/flows'
import {
  BankConnectionType,
  IntegrationErrorCodesType,
  unexpectedErrorCode,
} from '@linqpal/models/src/dictionaries'

export const usePayWithBlueTapeCredit = (
  userInfo: any,
  paymentMethods: any,
  windowFeatures: string | undefined,
  setPopupWindow: (window: Window | null) => void,
  setFlow: (flow: FLOWS) => void,
  setPaymentMethod: (method: IBankAccountModel | null) => void,
  setError: (error: IntegrationErrorCodesType) => void,
) => {
  return useCallback(async () => {
    if (!userInfo) return
    const creditLoCnumber = userInfo.company?.credit?.LoCnumber

    if (!creditLoCnumber) {
      try {
        await routes2.user.loanApplication()
        const newWindow = window.open(
          '/request-credit',
          '_blank',
          windowFeatures,
        )
        setPopupWindow(newWindow)
      } catch (err) {
        console.error(err)
        setError(unexpectedErrorCode)
      }
      return
    }

    const primaryForCreditMethod = paymentMethods.find(
      (_paymentMethod) => _paymentMethod.isPrimaryForCredit,
    )

    if (!primaryForCreditMethod) {
      setFlow(FLOWS.CONNECT_NEW_BANK_ACCOUNT)
      return
    }

    if (primaryForCreditMethod.isManualEntry) {
      setPaymentMethod(primaryForCreditMethod)
      setFlow(FLOWS.PAY_WITH_BLUETAPE_CREDIT_FLOW)
      return
    }

    if (
      !primaryForCreditMethod ||
      primaryForCreditMethod.connectionType !== BankConnectionType.PLAID ||
      primaryForCreditMethod.plaid?.status === 'expired' ||
      primaryForCreditMethod.plaid?.status === 'disconnected'
    ) {
      setFlow(FLOWS.CONNECT_NEW_BANK_ACCOUNT)
      return
    }

    setPaymentMethod(primaryForCreditMethod)
    setFlow(FLOWS.PAY_WITH_BLUETAPE_CREDIT_FLOW)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethods, userInfo, windowFeatures])
}
